import React from "react"
import {FaReddit, FaTwitter, FaFacebook} from "react-icons/all";
import {Flex, Box} from "@chakra-ui/react";
import {ChakraProps} from "@chakra-ui/system/dist/types/system.types";
import {Paragraph} from "../style";

const SocialLink: React.FC<ChakraProps> = (props) => {
    return <Box
        as="li"
        padding="0 1em"
        fontSize="1.5em"
        {...props}
    />
}

const Social = () => {
    return <div>
        <Paragraph>Follow us</Paragraph>
        <Flex
            as="ul"
            direction="row"
            listStyleType="none"
            margin={0}
            padding={0}
            justifyContent="center"
        >
            <SocialLink color="#ff4500">
                <a href="https://www.reddit.com/user/touhoufm">
                    <FaReddit />
                </a>
            </SocialLink>
            <SocialLink color="#1da1f2">
                <a href="https://twitter.com/TouhouFm">
                    <FaTwitter />
                </a>
            </SocialLink>
            <SocialLink color="#3b5998">
                <a href="https://www.facebook.com/touhou.fm/">
                    <FaFacebook />
                </a>
            </SocialLink>
        </Flex>
    </div>
}

export default Social